import { css } from '@emotion/react'
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap'
import { memo } from 'react'
import IconButton from './IconButton'

const buttonStyles = css({
    padding: 7,
})

interface FullWindowButtonProps {
    disabled?: boolean
    onClick(event?: any): void
    overrides?: any
}

const ButtonZoomIn = memo(
    ({ disabled, onClick, overrides }: FullWindowButtonProps) => (
        <IconButton
            title="Zoom Video"
            onClick={onClick}
            disabled={disabled}
            css={[buttonStyles, overrides]}
        >
            <ZoomInMapIcon />
        </IconButton>
    ),
)

export default ButtonZoomIn
